import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import SettingsDashboard from './SettingsDashboard'
import AdminSettings from './AdminSettings'

export default function Settings() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/settings" component={SettingsDashboard} />
				<Route exact path="/settings/admin" component={AdminSettings} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}